import { SubmissionActionConstants } from '../constants';

const submission = (state = null, action) => {
  if (action.type === SubmissionActionConstants.LOADING_SUBMISSION) {
    return { ...state, loading: true };
  }

  if (action.type === SubmissionActionConstants.SUBMISSION_RECEIVED) {
  	return action.submission
  }
    
  return state;
};

export default submission;


// WEBPACK FOOTER //
// ./src/reducers/submission.js